import { Injectable } from '@angular/core';
import { Subject, type Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { type EventBusMessage, type EventBusMessageKey } from '../models/event-bus-message.model';

@Injectable({
    providedIn: 'root',
})
export class EventBusService {
    private readonly eventBus: Subject<EventBusMessage>;

    public constructor() {
        this.eventBus = new Subject<EventBusMessage>();
    }

    /**
     * Publish a message/event to event bus.
     * @param event Event to broadcast.
     * @throws {Error} EventBusMessage key must be a string and must not be empty.
     */
    public emit(event: EventBusMessage): void {
        if (!event.key.trim().length) {
            throw new Error('EventBusMessage key must be a string and must not be empty');
        }

        this.eventBus.next(event);
    }

    /**
     * Returns an observable to recieve filtered messages/events based on the provied key.
     * @param key Key to identify the message/event.
     * @returns An observable to recieve filtered messages/events based on the provied key.
     */
    public on<T extends EventBusMessage>(key: EventBusMessageKey): Observable<T> {
        return this.eventBus.asObservable().pipe(
            filter((event: EventBusMessage) => event.key === key),
            map((event: EventBusMessage) => event as T),
        );
    }

}
